module.exports = __webpack_public_path__ + "static/media/Dropdown.91cdfcc6.png";